<template>
  <modalForm :title="$t('canned.deleteTitle')" :submit-label="$t('actions.remove')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel" fullScreen="true">
  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import modalForm from '../../building_blocks/modalForm'
import formViewMixin from '../../building_blocks/formViewMixin'
import cannedMessageModel from '@/models/cannedMessage'
import { useCannedMessagesStore } from '@/stores/cannedMessages';

export default {
  mixins: [formViewMixin],
  name: 'CannedDelete',
  props: ['message'],
  setup() {
    let cannedMessageStore = useCannedMessagesStore();
    return {
      cannedMessageStore,
      v$: useVuelidate()
    };
  },
  components: {
    modalForm,
  },
  methods: {
    async onFormValid() {
      let response = await cannedMessageModel.deleteMessage(this.message.id, this.axios, this.$root.token);
      if (response.status === 204) {
        this.cannedMessageStore.removeById(this.message.id);
        this.$emit('delete-finished-event');
      } else {
        alert(this.$t('canned.deleteError'));
      }
    },
    cancel() {
      this.$emit('delete-finished-event');
    }
  },
  data() {
    return {
    }
  },
  validations () {
    return {}
  }
}
</script>
